module.exports = __webpack_public_path__ + "img/aegcl.39d71f43.jpg";